import { isNull, isUndefined } from "util";

export const DecimalAsComma = (value : any) : string =>
{
	if (isNaN(value) || isNull(value) || isUndefined(value))
		return '';

	let numericValue = parseFloat(value);
	let stringValue = numericValue.toFixed(2);

	stringValue = stringValue.replace('.', ',');

	return stringValue;
}